'use client';

import React, { ReactNode } from 'react';

interface TeamProfilesProps {
  children: ReactNode; // Not used in this implementation
}

// Define profile data structure
interface Profile {
  name: string;
  image: string;
  bio: React.ReactNode;
}

// Hardcoded team profiles
const teamProfiles: Profile[] = [
  {
    name: "Daniel Kokotajlo",
    image: "./daniel.jpg",
    bio: (
      <>
        Daniel Kokotajlo (<a href="https://time.com/7012881/daniel-kokotajlo/" className="text-blue-600 hover:underline">TIME 100</a>, <a href="https://www.nytimes.com/2024/06/04/technology/openai-culture-whistleblowers.html" className="text-blue-600 hover:underline">NYT piece</a>) is a former OpenAI researcher whose <a href="https://www.lesswrong.com/posts/6Xgy6CAf2jqHhynHL/what-2026-looks-like" className="text-blue-600 hover:underline">previous AI predictions</a> <a href="https://www.lesswrong.com/posts/u9Kr97di29CkMvjaj/evaluating-what-2026-looks-like-so-far" className="text-blue-600 hover:underline">have held up well</a>.
      </>
    ),
  },
  {
    name: "Eli Lifland",
    image: "./daniel.jpg", // Using the same image as in the example
    bio: (
      <>
        <a href="https://www.linkedin.com/in/eli-lifland/" className="text-blue-600 hover:underline">Eli Lifland</a> cofounded <a href="https://theaidigest.org/" className="text-blue-600 hover:underline">AI Digest</a>, did <a href="https://scholar.google.com/citations?user=Q33DXbEAAAAJ&hl=en" className="text-blue-600 hover:underline">AI robustness research</a>, and ranks #1 on the <a href="https://www.rand.org/global-and-emerging-risks/forecasting-initiative.html" className="text-blue-600 hover:underline">RAND Forecasting Initiative</a> all-time leaderboard.
      </>
    ),
  },
];

const TeamProfiles: React.FC<TeamProfilesProps> = ({ children }) => {
  // Ignore children and render the hardcoded profiles
  return (
    <div className="my-8 font">
      <div className="flex flex-col gap-8">
        {teamProfiles.map((profile, index) => (
          <div 
            key={index} 
            className="flex flex-row gap-6 items-start sm:flex-row sm:text-left sm:items-start xs:flex-col xs:items-center xs:text-center"
          >
            <div className="flex-shrink-0">
              <img 
                src={profile.image} 
                alt={profile.name} 
                className="w-[100px] h-[100px] object-cover rounded-full"
              />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold mt-0 mb-2">{profile.name}</h3>
              <p>
                {profile.bio}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamProfiles; 